// src/teamPlan/teamPlan.ts
var TeamPlanUsageCapType = /* @__PURE__ */ ((TeamPlanUsageCapType2) => {
  TeamPlanUsageCapType2[TeamPlanUsageCapType2["AutoScale"] = 0] = "AutoScale";
  TeamPlanUsageCapType2[TeamPlanUsageCapType2["Capped"] = 1] = "Capped";
  return TeamPlanUsageCapType2;
})(TeamPlanUsageCapType || {});
var TeamPlanTier = /* @__PURE__ */ ((TeamPlanTier2) => {
  TeamPlanTier2[TeamPlanTier2["FREE"] = 0] = "FREE";
  TeamPlanTier2[TeamPlanTier2["GROWTH"] = 1] = "GROWTH";
  TeamPlanTier2[TeamPlanTier2["ENTERPRISE"] = 2] = "ENTERPRISE";
  TeamPlanTier2[TeamPlanTier2["OTHER"] = 3] = "OTHER";
  TeamPlanTier2[TeamPlanTier2["SCALE"] = 4] = "SCALE";
  TeamPlanTier2[TeamPlanTier2["PAYG"] = 5] = "PAYG";
  return TeamPlanTier2;
})(TeamPlanTier || {});
var TeamPlanTerm = /* @__PURE__ */ ((TeamPlanTerm2) => {
  TeamPlanTerm2[TeamPlanTerm2["MONTHLY"] = 0] = "MONTHLY";
  TeamPlanTerm2[TeamPlanTerm2["ANNUAL"] = 1] = "ANNUAL";
  return TeamPlanTerm2;
})(TeamPlanTerm || {});

export {
  TeamPlanUsageCapType,
  TeamPlanTier,
  TeamPlanTerm
};
//# sourceMappingURL=chunk-BHEHN6LJ.mjs.map